module.exports = __webpack_public_path__ + "static/media/iphone_14_midnight.0650f626.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_midnight.jpeg
// module id = 2125
// module chunks = 0